export interface EmergencyMessageParams {
  emergency_id: string;
  org_code: string;
  content?: string | null;
  message_kind: string;
  latitude?: number | null;
  longitude?: number | null;
  address?: string | null;
  sender_auth_id: string;
  sender_first_name: string;
  sender_last_name: string;
  sent_timestamp: number;
  object_type: string;
  unique_key: string;
  id: string;
  status?: string | null;
  _etag?: string;
  _ts?: number;
}

/**
 * Represents a single emergency chat/location message.
 */
export class EmergencyMessage {
  public emergency_id: string;
  public org_code: string;
  public content?: string | null;
  public message_kind: string;
  public latitude?: number | null;
  public longitude?: number | null;
  public address?: string | null;
  public sender_auth_id: string;
  public sender_first_name: string;
  public sender_last_name: string;
  public sent_timestamp: number;
  public object_type: string;
  public unique_key: string;
  public id: string;
  public status?: string | null;
  public _etag?: string;
  public _ts?: number;

  constructor({
    emergency_id,
    org_code,
    content = null,
    message_kind,
    latitude = null,
    longitude = null,
    address = null,
    sender_auth_id,
    sender_first_name,
    sender_last_name,
    sent_timestamp,
    object_type,
    unique_key,
    id,
    status = null,
    _etag = '',
    _ts = 0,
  }: EmergencyMessageParams) {
    this.emergency_id = emergency_id;
    this.org_code = org_code;
    this.content = content;
    this.message_kind = message_kind;
    this.latitude = latitude;
    this.longitude = longitude;
    this.address = address;
    this.sender_auth_id = sender_auth_id;
    this.sender_first_name = sender_first_name;
    this.sender_last_name = sender_last_name;
    this.sent_timestamp = sent_timestamp;
    this.object_type = object_type;
    this.unique_key = unique_key;
    this.id = id;
    this.status = status;
    this._etag = _etag;
    this._ts = _ts;
  }
}

/**
 * Sorts emergency messages by their sent timestamp in ascending order.
 */
export const sortByTimestamp = (
  messages: Array<EmergencyMessage>,
): Array<EmergencyMessage> => {
  return messages.slice().sort((a, b) => a.sent_timestamp - b.sent_timestamp);
};
